$(function() {
  if ($('body.infos').length < 1) return

  // submit
  $('.js-user-form-btn').on('click', function() {
    Rails.fire(document.querySelector('.js-user-form'), 'submit')
    $('.js-spinner-modal').modal('show')
  })
})
